import katex from 'katex';
import 'katex/dist/katex.min.css';

function renderMath(tex, displayMode) {
    try {
        return katex.renderToString(tex, {
            throwOnError: false,
            displayMode,
        });
    } catch (e) {
        return displayMode
            ? `<div class="text-red-500">${tex}</div>`
            : `<span class="text-red-500">${tex}</span>`;
    }
}

export default function LatexRenderer({ text }) {
    if (!text) return null;

    // Split text by block math first, then inline math.
    const blockRegex = /\$\$([\s\S]*?)\$\$/g;
    const inlineRegex = /\$([\s\S]*?)\$/g;

    const parts = [];
    let lastIndex = 0;
    let match;

    while ((match = blockRegex.exec(text)) !== null) {
        if (match.index > lastIndex) {
            parts.push({ type: 'text', content: text.slice(lastIndex, match.index) });
        }
        parts.push({ type: 'block-math', content: match[1] });
        lastIndex = blockRegex.lastIndex;
    }

    if (lastIndex < text.length) {
        parts.push({ type: 'text', content: text.slice(lastIndex) });
    }

    const elements = parts.map((part, i) => {
        if (part.type === 'block-math') {
            return (
                <div
                    key={i}
                    dangerouslySetInnerHTML={{ __html: renderMath(part.content, true) }}
                    className="my-2 overflow-x-auto"
                />
            );
        }

        // Process inline math within text segment
        const segments = [];
        let inlineLast = 0;
        let inlineMatch;

        while ((inlineMatch = inlineRegex.exec(part.content)) !== null) {
            if (inlineMatch.index > inlineLast) {
                segments.push({ type: 'text', content: part.content.slice(inlineLast, inlineMatch.index) });
            }
            segments.push({ type: 'inline-math', content: inlineMatch[1] });
            inlineLast = inlineRegex.lastIndex;
        }

        if (inlineLast < part.content.length) {
            segments.push({ type: 'text', content: part.content.slice(inlineLast) });
        }

        return (
            <span key={i}>
                {segments.map((seg, j) => {
                    if (seg.type === 'inline-math') {
                        return (
                            <span
                                key={j}
                                dangerouslySetInnerHTML={{ __html: renderMath(seg.content, false) }}
                            />
                        );
                    }
                    return (
                        <span key={j} className="whitespace-pre-wrap">
                            {seg.content}
                        </span>
                    );
                })}
            </span>
        );
    });

    return <div className="leading-relaxed">{elements}</div>;
}
